import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskCardComponent } from './task-card/task-card.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { AssignmentCardComponent, AssignmentCardContentArea } from './assignment-card/assignment-card.component';
import { ContentImageCardComponent } from './content-image-card/content-image-card.component';
import { PlaylistComponent } from './playlist/playlist.component';
import { FlipBlockComponent } from './flip-block/flip-block.component';
import { PipeModule } from '@app/system/pipes/pipe.module';
import { FlipItemIcon, FlipItemTitle, FlipItemContentArea, FlipItemDateCaption, FlipItemDate, FlipBlockItemComponent, FlipItemStatus } from './flip-block/flip-block-item/flip-block-item.component';
import { ChipsModule } from '../chips/chips.module';
import { BadgeModule } from '../badge/badge.module';
import { EventCardComponent } from './event-card/event-card.component';
import { PlaylistCardComponent } from './playlist-card/playlist-card.component';
import { QuestionCardComponent } from './question-card/question-card.component';
import { ProfileCardComponent } from './profile-card/profile-card.component';
import { MatDividerModule } from '@angular/material/divider';
import { DirectivesModule } from '@app/system/directives/directives.module';
import { RequestCardComponent } from './request-card/request-card.component';
import { LeaderboardCardComponent } from './leaderboard-card/leaderboard-card.component';
import { InfoCardComponent } from './info-card/info-card.component';
import { AssessmentQuestionCardComponent } from './assessment-question-card/assessment-question-card.component';
import { ProfileListCardComponent } from './profile-list-card/profile-list-card.component';
import { ChatQuestionCardComponent } from './chat-question-card/chat-question-card.component';

@NgModule({
    declarations: [
        TaskCardComponent,
        AssignmentCardComponent,
        ContentImageCardComponent,
        PlaylistComponent,
        FlipBlockComponent,
        FlipItemIcon,
        FlipItemTitle,
        FlipItemContentArea,
        FlipItemDateCaption,
        FlipItemDate,
        FlipItemStatus,
        FlipBlockItemComponent,
        AssignmentCardContentArea,
        EventCardComponent,
        PlaylistCardComponent,
        QuestionCardComponent,
        ProfileCardComponent,
        RequestCardComponent,
        LeaderboardCardComponent,
        InfoCardComponent,
        AssessmentQuestionCardComponent,
        ProfileListCardComponent,
        ChatQuestionCardComponent
    ],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatIconModule,
        MatButtonModule,
        MatProgressBarModule,
        MatTooltipModule,
        PipeModule,
        ChipsModule,
        BadgeModule,
        MatDividerModule,
        DirectivesModule
    ],
    exports: [
        TaskCardComponent,
        AssignmentCardComponent,
        ContentImageCardComponent,
        PlaylistComponent,
        FlipBlockComponent,
        FlipItemIcon,
        FlipItemTitle,
        FlipItemContentArea,
        FlipItemDateCaption,
        FlipItemDate,
        FlipItemStatus,
        FlipBlockItemComponent,
        AssignmentCardContentArea,
        EventCardComponent,
        PlaylistCardComponent,
        QuestionCardComponent,
        ProfileCardComponent,
        RequestCardComponent,
        LeaderboardCardComponent,
        InfoCardComponent,
        AssessmentQuestionCardComponent,
        ProfileListCardComponent,
        ChatQuestionCardComponent
    ]
})
export class WidgetModule { }
